import { toAbsoluteUrl } from "../../../toAbsoluteUrl";
import React, { useState, useEffect } from "react";
import { callApi } from "../../../API";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { useSearchParams } from "react-router-dom";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 490,
  bgcolor: "background.paper",
  padding: 3,
  borderRadius: "16px",
  background: "var(--Neutrals-White, #FFF)", // using CSS variable with fallback
  border: "unset",
  display: "flex",
  flexDirection: "column",
  gap: "24px",
  minHeight: 290,

  "@media (max-width: 767px)": {
    width: "100%", // Full width for screens smaller than 600px
    padding: "16px",
    // height: "100%",
    borderRadius: "25px 25px 0px 0px",
    bottom: 0,
    top: "auto",
    transform: "translate(-50%, 0)",
    minHeight: 230,
  },
};
export default function InvitePage(props) {
  const [currentStep, setCurrentStep] = useState(1);
  const [paymentSelected, setPaymentSelected] = useState("");
  const [showPaymentError, setShowPaymentError] = useState(false);
  const [showAmountError, setShowAmountError] = useState(false);
  const [showSuccessPaymentMessage, setShowSuccessPaymentMessage] =
    useState(false);
  const [successType, setSuccessType] = useState(0);
  const [amount, setAmount] = useState("");
  const [transactionId, setTransactionId] = useState("");
  const [iban, setIban] = useState("");
  const [branchName, setBranchName] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [currency, setCurrency] = useState("");
  const [accountTitle, setAccountTitle] = useState("");
  const [bankName, setBankName] = useState("");
  const [showBankDetails, setShowBankDetails] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const [loading, setLoading] = useState(false);
  const domain = window.API_DASHBOARD_DATA;
  const imageDomain =  "https://" + window.location.hostname + "/" +'en/'

  useEffect(() => {
    getBankDetails();
    if (props.transactionId) {
      setTransactionId(props.transactionId);
      
      
      setShowSuccessPaymentMessage(props.statusOfPayment);
      props.statusOfPayment == 1 ? setSuccessType(1) : setSuccessType(2);
      setPaymentSelected(1);
    }
  }, []);
  function openBankDetails(params) {
    setShowBankDetails(!showBankDetails);
  }
  function getBankDetails(params) {
    let paymentToAPI = "";
    if (paymentSelected == 1) {
      paymentToAPI = 2;
    } else {
      paymentToAPI = 1;
    }
    const domain = window.API_DASHBOARD_DATA;
    callApi(domain, {
      type: "viewBankDetails",
    })
      .then((data) => {
        setIban(data.bankDetails.IBAN);
        setBranchName(data.bankDetails.branchName);
        setAccountNumber(data.bankDetails.accountNumber);
        setAccountTitle(data.bankDetails.accountTitle);
        setCurrency(data.bankDetails.currancy);
        setBankName(data.bankDetails.bankName);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  function nextStep(next) {
    if ((paymentSelected == "" && next == 1) || (amount == "" && next == 2)) {
      next == 1 ? setShowPaymentError(true) : setShowAmountError(true);
    } else {
      setCurrentStep(currentStep + 1);
      setShowPaymentError(false);
      setShowAmountError(false);
    }
  }
  function LastStep() {
    setCurrentStep(currentStep - 1);
    setShowPaymentError(false);
    setShowAmountError(false);
  }
  function selectMethod(paymentNumber) {
    setPaymentSelected(paymentNumber);
    setShowPaymentError(false);
  }
  function displayPaymentMethods(params) {
    return (
      <div className="payment-methods-section">
        <div
          className={`payment-methods ${paymentSelected == 1 && "selected"} `}
          onClick={() => {
            selectMethod(1);
          }}
        >
          <div className="d-flex gap-8 align-items-center">
            <div className="check-payment">
              <div />
            </div>
            <div className="d-flex gap-12 align-items-center">
              <img
                src={toAbsoluteUrl("/media/images/credit-card.svg")}
                alt="credit card"
                className="notDark"
              />
              <img
                src={toAbsoluteUrl("/media/images/credit-card-dark.svg")}
                alt="credit card"
                className="darkMode"
              />
              <p>Credit Card Payment</p>
            </div>
          </div>
        </div>
        <div
          className={`payment-methods ${paymentSelected == 2 && "selected"} `}
          onClick={() => {
            selectMethod(2);
          }}
        >
          <div className="d-flex gap-8 align-items-center">
            <div className="check-payment">
              <div />
            </div>
            <div className="d-flex gap-12 align-items-center">
              <img
                src={toAbsoluteUrl("/media/images/bank-line.svg")}
                alt="credit card"
                className="notDark"
              />
               <img
                src={toAbsoluteUrl("/media/images/bank-line-dark.svg")}
                alt="credit card"
                 className="darkMode"
              />
              <p>Bank Transfer Payment</p>
            </div>
          </div>

          <p
            onClick={() => {
              openBankDetails();
            }}
            className="view-bankDetails pointer"
          >
            {showBankDetails ? "Hide details" : "View details"}{" "}
          </p>
        </div>
        {showBankDetails && (
          <div>
            <div className="information-message">
              <img
                src={toAbsoluteUrl("/media/images/alert-circle.svg")}
                alt="remove-icon"
              />
              <p>Payment will take up to 72 hours to be confirmed</p>
            </div>
            {displayBankData()}
          </div>
        )}
      </div>
    );
  }
  function closeModal(params) {
    searchParams.delete("id");
    searchParams.delete("status");
    setSearchParams(searchParams);
    props.closeModal();
    setTransactionId("");
    setShowSuccessPaymentMessage(false);
    setSuccessType(0);
    setPaymentSelected("");
  }
  function displayConfirmPayment(params) {
    return (
      <div className="payment-details">
        <div className="w-100">
          <spn>Amount</spn>
          <p className="bold-p mt-2">{amount}AED</p>
        </div>
        <div className="w-100">
          <spn>Payment method</spn>
          <p className="bold-p mt-2">
            {paymentSelected == 1 ? "Credit Card" : "Bank Transfer"}
          </p>
        </div>
      </div>
    );
  }
  function validationAmount(e) {
    e.target.value = e.target.value.replace(/[^0-9.]/g, "");
    setAmount(e.target.value);
    // Prevent multiple decimal points
    if ((e.target.value.match(/\./g) || []).length > 1) {
      e.target.value = e.target.value.slice(0, -1);
    }
    if (e.target.value.startsWith("0") && !e.target.value.startsWith("0.")) {
      e.target.value = e.target.value.slice(1); // Remove the leading zero
    }

    setAmount(e.target.value);
  }
  function displaySelectedPaymentMethod(params) {
    return (
      <div className="selected-payment-section column-gap-16">
        <p className=""> Selected Method</p>
        {paymentSelected == 1 ? (
          <div className="d-flex gap-8 align-items-center">
            <img className="notDark" src={toAbsoluteUrl("/media/images/credit-selected.svg")} />
            <img className="darkMode" src={toAbsoluteUrl("/media/images/credit-selected-dark.svg")} />
            <p className="bold-p">Credit Card</p>
          </div>
        ) : (
          <div className="d-flex gap-8 align-items-center">
            <img className="notDark" src={toAbsoluteUrl("/media/images/bank-line-selected.svg")} />
            <img className="darkMode" src={toAbsoluteUrl("/media/images/bank-line-selected-dark.svg")} />
            <p className="bold-p">Bank Transfer</p>
          </div>
        )}
        <div className="enter-amount-section column-gap-16 mt-4">
          <p>Enter an Amount</p>
          <div className="input-of-amount">
            <div className="currency">
              <p className="bold-p">AED</p>
            </div>
            <input
              type="text"
              placeholder="0.0"
              value={amount}
              onInput={(e) => {
                validationAmount(e);
              }}
            />
          </div>
        </div>
      </div>
    );
  }
  function confirmPayment(params) {
    setLoading(true)
    let paymentToAPI = "";
    if (paymentSelected == 1) {
      paymentToAPI = 2;
    } else {
      paymentToAPI = 1;
    }
    
    callApi(
      domain,
      {
        type: "topupChargeing",
        // bussinessUserId: 2974,
        paymentMethod: paymentToAPI,
        amount: amount,
      },
      "",
      "POST"
    )
      .then((data) => {
        setLoading(false)
        if (paymentSelected == 1) {
          window.location = data.redirectUrl;
        } else {
          setTransactionId(data.transactionId);
          setShowSuccessPaymentMessage(true);
          setSuccessType(1);
        }
      })
      .catch((error) => {
        console.log(error);
        setShowSuccessPaymentMessage(true);
        setSuccessType(0);
      });
  }
  const copyToClipboard = () => {
    console.log('transactionId',transactionId);
    
    navigator.clipboard.writeText(transactionId)
      .then(() => {
        console.log('transactionId',transactionId);
        
      })
      .catch(err => {
        console.error("Failed to copy: ", err);
      });
  };
  function displayPaymentError(params) {
    return (
      <>
        {successType == 1 ? (
          <>
            {paymentSelected == 1 ? (
              <div className="text-center">
                <img
                  onClick={() => closeModal()}
                  src={toAbsoluteUrl("/media/images/success-payment.svg")}
                  className="notDark"
                />
                 <img
                  onClick={() => closeModal()}
                  src={toAbsoluteUrl("/media/images/success-payment-dark.svg")}
                  className="darkMode"
                />
                <div className="mt-5">
                  <h2>Thank you for your payment</h2>
                  <div className="d-flex gap-1 justify-content-center mt-3">
                    <p>Transaction ID: {transactionId}</p>
                    <img
                      onClick={copyToClipboard}
                      src={toAbsoluteUrl("/media/images/copy.svg")}
                      className="pointer notDark"
                    />
                    <img
                      onClick={copyToClipboard}
                      src={toAbsoluteUrl("/media/images/copy-dark.svg")}
                      className="pointer darkMode"
                    />
                  </div>
                </div>
              </div>
            ) : (
              <div className="text-center">
                <img
                  onClick={() => closeModal()}
                  src={toAbsoluteUrl("/media/images/success-payment.svg")}
                  className="notDark"
                />
                 <img
                  onClick={() => closeModal()}
                  src={toAbsoluteUrl("/media/images/success-payment-dark.svg")}
                  className="darkMode"
                />
                <div className="mt-5">
                  <h2>Thank you for your payment</h2>
                  <div className="d-flex gap-1 justify-content-center mt-2">
                    <p>Transaction ID: {transactionId}</p>
                    <img
                      onClick={copyToClipboard}
                      src={toAbsoluteUrl("/media/images/copy.svg")}
                      className="pointer notDark"
                    />
                    <img
                      onClick={copyToClipboard}
                      src={toAbsoluteUrl("/media/images/copy-dark.svg")}
                      className="pointer darkMode"
                    />
                  </div>
                  <p className="mt-3 payment-bank-info">
                    Your transaction is pending for the next 72 hours only.
                    <br /> Please provide us with the payment confirmation by
                    emailing a copy of the transfer receipt mentioning the
                    transaction number to
                    <a href="mailto: operations@thinkprop.ae">
                      {" "}
                      operations@thinkprop.ae{" "}
                    </a>{" "}
                    to confirm your order.
                  </p>
                  {displayBankData()}
                  <p className="mt-5 payment-bank-info">
                    If you have any questions, feel free to contact us at <br />
                    <a href="mailto: operations@thinkprop.ae">
                      support@thinkprop.ae
                    </a>
                  </p>
                </div>
              </div>
            )}
          </>
        ) : (
          <div className="text-center">
            <img
              onClick={() => closeModal()}
              src={toAbsoluteUrl("/media/images/error-payment-icon.svg")}
              className=""
            />
            <div className="mt-5">
              <h2>An error occurred while processing your payment</h2>
              <div className="d-flex gap-1 justify-content-center mt-4">
                <p>Transaction ID: {transactionId}</p>
                <img
                      onClick={copyToClipboard}
                      src={toAbsoluteUrl("/media/images/copy.svg")}
                      className="pointer notDark"
                    />
                    <img
                      onClick={copyToClipboard}
                      src={toAbsoluteUrl("/media/images/copy-dark.svg")}
                      className="pointer darkMode"
                    />
              </div>
            </div>
          </div>
        )}
      </>
    );
  }
  function displayBankData(params) {
    return (
      <div className="bank-details">
        <div className="d-flex gap-16">
          <div className="w-100">
            <span>IBAN</span>
            <p>{iban}</p>
          </div>
          <div className="w-100">
            <span>Bank Name</span>
            <p>{bankName}</p>
          </div>
        </div>
        <div className="divider" />
        <div className="d-flex gap-16">
          <div className="w-100">
            <span>Branch</span>
            <p>{branchName}</p>
          </div>
          <div className="w-100">
            <span>Account Number</span>
            <p>{accountNumber}</p>
          </div>
        </div>
        <div className="divider" />
        <div className="d-flex gap-16">
          <div className="w-100">
            <span>Account Title</span>
            <p>{accountTitle}</p>
          </div>
          <div className="w-100">
            <span>Currency:</span>
            <p>{currency}</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      <Modal
        className="react-style"
        open={props.open}
        onClose={props.closeModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        {!showSuccessPaymentMessage ? (
          <Box sx={style}>
            <div className="column-gap-16">
              <div className="d-flex justify-content-between header-of-modal ">
                <h2>Wallet Top-up</h2>
                <img
            onClick={() => props.closeModal()}
            src="/businessDashboard/media/images/Close-x.svg"
            className="pointer close-image notDark"
          />
          <img
            onClick={() => props.closeModal()}
            src="/businessDashboard/media/images/Close-x-dark.svg"
            className="pointer close-image darkMode"
          />
              </div>
              {currentStep == 1 && <p className="select-text">Select payment method</p>}
            </div>
            {showPaymentError && (
              <div className="error-message">
                <img className="notDark"
                        src={toAbsoluteUrl("/media/images/x-octagon.svg")}
                        alt="alert-icon"
                      />
                      <img className="darkMode"
                        src={toAbsoluteUrl("/media/images/x-octagon-dark.svg")}
                        alt="alert-icon"
                      />
                <p>Please choose your payment method.</p>
              </div>
            )}
            {showAmountError && (
              <div className="error-message">
                <img className="notDark"
                        src={toAbsoluteUrl("/media/images/x-octagon.svg")}
                        alt="alert-icon"
                      />
                      <img className="darkMode"
                        src={toAbsoluteUrl("/media/images/x-octagon-dark.svg")}
                        alt="alert-icon"
                      />
                <p>Please enter the amount.</p>
              </div>
            )}
            {currentStep == 1
              ? displayPaymentMethods()
              : currentStep == 2
              ? displaySelectedPaymentMethod()
              : currentStep == 3
              ? displayConfirmPayment()
              : ""}
            {currentStep == 1 ? (
              <button
                className="rounded-btn-default w-100"
                onClick={() => nextStep(1)}
              >
                Next
              </button>
            ) : currentStep == 2 ? (
              <div className="d-flex gap-12">
                <button
                  onClick={() => {
                    LastStep();
                  }}
                  className="outline-btn w-100"
                >
                  Back
                </button>
                <button
                  className={`rounded-btn-default w-100`}
                  onClick={() => {
                    nextStep(2);
                  }}
                >
                  Next
                </button>
              </div>
            ) : currentStep == 3 ? (
              <div className="d-flex gap-12">
                <button
                  onClick={() => {
                    LastStep();
                  }}
                  className="outline-btn w-100"
                >
                  Back
                </button>
                <button
                  className={`rounded-btn-default w-100`}
                  onClick={() => {
                    if (!loading) {
                      confirmPayment()
                    }
                  }}
                >
                  Confirm
                  {loading && 
                    <div class="spinner-border white-color" role="status">
                      <span class="sr-only"></span>
                    </div>
                  }
                </button>
              </div>
            ) : (
              ""
            )}
          </Box>
        ) : (
          <Box sx={style}>
            <div className="d-flex justify-content-between header-of-modal ">
              <h2></h2>
              <img
                onClick={() => closeModal()}
                src={toAbsoluteUrl("/media/images/Close-x.svg")}
                className="pointer close-image notDark"
              />
              <img
                onClick={() => closeModal()}
                src={toAbsoluteUrl("/media/images/Close-x-dark.svg")}
                className="pointer close-image darkMode"
              />
            </div>
            {displayPaymentError()}
           { console.log(successType,'showSuccessPaymentMessage',imageDomain)}
            {successType !== 1  && (
              <a href= {`${imageDomain}contactUs`} className="rounded-btn-default w-100 pointer">Contact Us</a>
            )}
          </Box>
        )}
      </Modal>
    </>
  );
}
